import { createContext, useState, useEffect, useCallback } from "react"


export const EventsController = createContext({})

export function EventsControllerContextProvider({ children }) {

	const [timeoutsIds, setTimeoutsIds] = useState({})

	const addTimeout = useCallback((eventId, timeoutId) => {
		console.log('addTimeout:', eventId, timeoutId)
		if (timeoutsIds[eventId]) {
			console.log('já existe um timeout para esse evento: ', eventId, timeoutsIds[eventId])
			console.log('Removendo evento anterior e criando novo')
			removeTimeoutByEventId(eventId)
		}
		setTimeoutsIds((old) => ({...old, [eventId]: timeoutId}))
	}, [])

	function removeTimeoutByEventId(eventId) {
		console.log('removeTimeoutById: ', eventId)
		const timeoutId = timeoutsIds[eventId]
		clearTimeout(timeoutId)
		setTimeoutsIds((old) => {
			const newObj = {...old}
			delete newObj.eventId
			return {...newObj}
		})
	}

	function removeAllTimeouts() {
		Object.values(timeoutsIds).forEach(timeoutId => {
			console.log('removeAllTimeouts', timeoutId)
			clearTimeout(timeoutId)
		})
		setTimeoutsIds({})
	}

	useEffect(() => {
		console.log('timeoutsIds: ', timeoutsIds)
	}, [timeoutsIds])

	return (
		<EventsController.Provider value={{ addTimeout, removeTimeoutByEventId, removeAllTimeouts }}>
			{children}
		</EventsController.Provider>
	)
}
